import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Lightbox } from '../../../components/lightbox';
import * as _ from 'lodash';
import { dealError } from '../../error-handler';
import { NzModalService } from 'ng-zorro-antd/modal';
import { CustomerInfoService } from '../../../pages/customer-info/customer-info.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import * as downloadjs from 'downloadjs';

@Component({
  selector: 'app-file-preview-list',
  templateUrl: './file-preview-list.component.html',
  styleUrls: ['./file-preview-list.component.scss']
})
export class FilePreviewListComponent implements OnInit, OnDestroy {
  @Input() cos: any;
  @Input() localCOS: any;
  @Input() originFileList: any[] = [];
  isShowVideoModal = false;
  _showPreviewModal = false;
  @Input()
  set showPreviewModal(v) {
    this._showPreviewModal = v;
  }
  get showPreviewModal() {
    return this._showPreviewModal;
  }

  @Output() closePreviewModal = new EventEmitter();
  albums: any[] = [];
  videoInfo = null;

  constructor(
    private lightbox: Lightbox,
    private modal: NzModalService,
    private customerInfoService: CustomerInfoService,
    private message: NzMessageService,
    ) { }

  ngOnInit(): void {
  }

  handleClosePreviewModal(message = 'close') {
    this._showPreviewModal = false;
    this.closePreviewModal.emit(message);
  }
  getFileIcon(type: string): string {
    const basePath = 'assets/images/';
    switch (type) {
      case 'pdf':
        return `${basePath}pdf.png`;
      case 'word':
        return `${basePath}word.png`;
      case 'excel':
        return `${basePath}excel.png`;
      default:
        return '';
    }
  }
  getDownloadName(item: any): string {
    const raw = item?.fileName || item?.name || '';
    if (!raw) {
      return '';
    }
    const dotIdx = raw.lastIndexOf('.');
    if (dotIdx <= 0) {
      return raw;
    }
    const name = raw.substring(0, dotIdx);
    const ext = raw.substring(dotIdx);
    const match = name.match(/^(.*)_\d{10,}$/);
    const cleaned = match && match[1] ? match[1] : name;
    return `${cleaned}${ext}`;
  }
  openPreview(index) {
    const imgArr = [...this.localCOS.fileList, ...this.cos.fileList];
    console.log(imgArr);
    this.albums = [];
    for (const img of imgArr) {
      this.albums.push({
        src: img.url,
        caption: img.name || '',
        thumb: img.url,
        fileDataType: img.fileDataType,
        originFile: img.originFileObj
      });
    }
    this.lightbox.open(this.albums, index, {showZoom: true, showRotate: true, centerVertically: true});
  }
  openPreviewVideo(file){
    this.isShowVideoModal = true;
    this.videoInfo = file;
  }
  closeVideoModal(){
    this.isShowVideoModal = false;
  }

  confirmDeleteFile(fileList, index) {
    this.modal.confirm({
      nzTitle: '系统确认',
      nzContent: `<i nz-icon nzType="exclamation-circle" nzTheme="outline"></i>    确认删除附件？`,
      nzOkText: '是',
      nzOkType: 'primary',
      nzOnOk: () => {
        this.deleteFile(fileList, index);
      },
      nzCancelText: '否',
      nzOnCancel: () => {
      },
    });
  }

  deleteFile(fileList, index) {
    if (fileList[index]) {
      const file = _.find(this.originFileList, o => o.filePath === fileList[index].uid);
      if (file) {
        this.customerInfoService.deleteEFilePhoto([file]).subscribe(
          data => {
            fileList.splice(index, 1);
            this.message.success('删除成功');
            if (fileList.length === 0) {
              this.handleClosePreviewModal('fileClear');
            }
          },
          error => {
            this.message.error(dealError('删除附件', error));
          }
        );
      }
    }
  }

  download(fileList, index) {
    downloadjs(fileList[index].originFileObj || fileList[index].url, fileList[index].name);
  }

  ngOnDestroy() {
  }
}
